import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
	faSignOutAlt, faCaretSquareDown, faSearch, faTrash, faTrashAlt, faCaretRight, faComment, faComments, faEnvelope, faVolumeUp, faMicrophone, faMicrophoneSlash, faVolumeMute, faExclamation, faPlus, faSave, faFilePdf, faPhone, faClock, faAngleDown, faUserAlt, faPlay, faCheck, faVideo, faAngleLeft, faPen, faAngleRight, faCircle, faCircleNotch, faTimes, faSpinner, faCalendar, faCalendarAlt, faCalendarWeek, faPaperclip, faAngleUp, faHome, faInfo, faCog, faNotesMedical
} from '@fortawesome/free-solid-svg-icons';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageDrawingModule } from 'ngx-image-drawing';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { ClickOutsideModule } from 'ng-click-outside';
import { MaterialModule } from './material.module';
import { SearchDossierComponent } from './components/search-dossier/search-dossier.component';

import { PhotoUploadComponent } from './components/photo-upload/photo-upload.component';
import { ModalComponent } from './components/modal/modal.component';
import { UserConfirmationComponent } from './components/user-confirmation/user-confirmation.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { FileTypeSelectionComponent } from './components/file-type-selection/file-type-selection.component';
import { PhotoViewerComponent } from './components/photo-viewer/photo-viewer.component';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { NumbersOnlyDirective } from './directives/number-formatter.directive';
import { PhoneNumberOnlyDirective } from './directives/phonenumber-formatter.directive';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		FontAwesomeModule,
		ImageDrawingModule,
		MaterialModule,
		ReactiveFormsModule,
		IvyCarouselModule,
		ClickOutsideModule
	],
	declarations: [
		SearchDossierComponent,
		PhotoUploadComponent,
		ModalComponent,
		UserConfirmationComponent,
		FileUploadComponent,
		FileTypeSelectionComponent,
		PhotoViewerComponent,
		StopPropagationDirective,
		NumbersOnlyDirective,
		PhoneNumberOnlyDirective
	],
	exports: [
		FontAwesomeModule,
		FormsModule,
		MaterialModule,
		ClickOutsideModule,
		ModalComponent,
		PhotoUploadComponent,
		SearchDossierComponent,
		UserConfirmationComponent,
		FileUploadComponent,
		PhotoViewerComponent,
		StopPropagationDirective,
		NumbersOnlyDirective,
		PhoneNumberOnlyDirective
	],
	providers: [
		{ provide: Window, useValue: window }
	]
})
export class SharedModule {

	constructor(
		private library: FaIconLibrary
	) {
		library.addIcons(
			faAngleDown,
			faCaretSquareDown,
			faSearch,
			faTrash,
			faTrashAlt,
			faCaretRight,
			faComment,
			faComments,
			faEnvelope,
			faVolumeMute,
			faVolumeUp,
			faMicrophone,
			faMicrophoneSlash,
			faExclamation,
			faPlus,
			faNotesMedical,
			faPhone,
			faPlus,
			faSave,
			faFilePdf,
			faUserAlt,
			faPlay,
			faCheck,
			faVideo,
			faAngleLeft,
			faPen,
			faAngleRight,
			faAngleUp,
			faHome,
			faCircle,
			faCircleNotch,
			faSignOutAlt,
			faClock,
			faSpinner,
			faTimes,
			faCalendar,
			faCalendarAlt,
			faCalendarWeek,
			faPaperclip,
			faInfo,
			faCog
		);
	}
}
